import React, { Fragment, useContext } from "react";
import { Container, Row, Col } from "reactstrap";
import { Link } from "react-router-dom";
import { Home } from "react-feather";
import H3 from "../Headings/H3Element";
import CustomizerContext from "../../_helper/Customizer";
import CommonToolTip from "../../Components/Common/Component/CommonToolTip";
const Breadcrumbs = (props) => {
  return (
    <Fragment>
      <Container fluid={true}>
        <div className="page-title">
          <Row>
            <Col xs="4">
              {/* <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link
                    to={`${process.env.PUBLIC_URL}/${localStorage.getItem('homePage')}`}
                  >
                    <Home />
                  </Link>
                </li>
                <li className="breadcrumb-item">{props.parent}</li>
                {props.subParent ? (
                  <li className="breadcrumb-item">{props.subParent}</li>
                ) : (
                  ""
                )}
                <li className="breadcrumb-item active">{props.title}</li>
              </ol> */}
              {/* <H3>{props.mainTitle}</H3> */}
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginTop: "5%",
                }}
              >
                {props.span4 ? <span>{props.span4}</span> : ""}
                {props.span5 ? <span>{props.span5}</span> : ""}
                {props.span6 ? <span>{props.span6}</span> : ""}
              </div>
            </Col>
            <Col xs="8" className="table-options">
              <div className="reset-filter">
                {props?.checkResetFilter && props?.checkResetFilter() ? (
                  <>
                    <button id="reset-filter" className="btn" onClick={()=>{
                      props?.resetFilter()
                    }}>
                      <i className="fa fa-refresh"></i>
                    </button>
                    <CommonToolTip
                      options={{
                        placement: "top",
                        target: "reset-filter",
                      }}
                    >
                      Reset Filter
                    </CommonToolTip>
                  </>
                ) : (
                  ""
                )}
              </div>
              <div className="quickfilter-button">
                {props.quickfilter ? <span>{props.quickfilter}</span> : ""}
              </div>
              <div>
                {props.exportBtn ? <span>{props.exportBtn}</span> : ""}
              </div>
              <div className="select-buttons">
                {props.span1 ? <span>{props.span1}</span> : ""}
                {props.span2 ? <span>{props.span2}</span> : ""}
              </div>
              <div className="search-table">
                {props.span3 ? <span>{props.span3}</span> : ""}
              </div>
            </Col>
          </Row>
        </div>
      </Container>
    </Fragment>
  );
};

export default Breadcrumbs;
